import { Course, HelperResult } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useFollowedCourses } = getCRUDHooks<Course>({
  entityName: 'followedCourses',
  find: ({ userId, filters }): HelperResult<Course[]> =>
    clientApi.getOCClient().helpers.user.users.id(userId).followedCourses.find(filters),
});

// eslint-disable-next-line import/prefer-default-export
export { useFollowedCourses };
